<template>
  <div>
    <div class="max-w-[60ch]">
      <div class="mt-[32px]">
        <p class="mt-[8px] font-neo-screen-head">
          <strong> Name:</strong>
          {{ formData?.firstName }} {{ formData?.lastName }}
        </p>

        <p class="mt-[8px] font-neo-screen-head">
          <strong>{{ messageCustomerNumber }}:</strong>
          {{ formData?.customerNumber }}
        </p>

        <p class="mt-[8px] font-neo-screen-head">
          <strong>{{ messageEmail }}:</strong>
          {{ formData?.email }}
        </p>
      </div>

      <UtilityText
        class="mt-[32px]"
        :text="$t('dbc-cancel-contract-completed-we-will-get-back-to-you')"
      />

      <div class="mt-[32px]">
        <small>{{ messageGreetings }}</small>
      </div>
    </div>

    <div class="dbc-btn-group mt-[24px] mb-[160px] print:hidden">
      <UtilityButton
        class="[&>a]:h-full"
        :button="{
          type: 'ghost',
          link: getPagePath['home']![locale]!,
          text: $t('dbc-button-return-to-home'),
        }"
      />

      <FormKit
        type="button"
        data-test="printButton"
        :label="$t('dbc-text-cancel-contract-completed-print-cancellation')"
        prefix-icon="printIcon"
        input-class="dbc-gc-btn dbc-btn--icon dbc-gc-btn--primary dbc-gc-form__button"
        @click="onPrint"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  formData: CancelContractData | null
}>()

const { t, locale } = useI18n()

const client = useRuntimeConfig().public.client
const clientMap = useRuntimeConfig().public.clientMapping as ClientMapping

function onPrint() {
  window.print()
}

const messageCustomerNumber = t('dbc-cancel-contract-input-number-label')

const messageEmail = t('dbc-cancel-contract-input-email-label')

const messageGreetings = ref(t('dbc-text-greetings-from-us'))
messageGreetings.value = messageGreetings.value!.replace(
  '[placeholder]',
  clientMap[client]!
)
</script>
